import {
  START_LOADING,
  STOP_LOADING,
  ERROR,
  SUCCESS,
  GET_REFERRER,
  EDIT_REFERRER,
  GET_ACTIVE_REFERRERS,
} from "../types/index.js";

const initialState = {
  IsError: false,
  isSuccess: false,
  isLoading: false,
  referrerList: { data: [] },
  activeReferrers: [],
};

const ReferrerReducer = (state = initialState, action) => {
  switch (action.type) {
    case START_LOADING:
      return { ...state, isLoading: true };
    case STOP_LOADING:
      return { ...state, isLoading: false };
    case GET_REFERRER:
      return {
        ...state,
        referrerList: action.payload,
      };
    case EDIT_REFERRER:
      return {
        ...state,
        referrerList: {
          ...state.referrerList,
          data: state.referrerList.data.map((item) =>
            item.referrerID === action.payload.data.referrerID
              ? action.payload.data
              : item
          ),
        },
      };
    case GET_ACTIVE_REFERRERS:
      return {
        ...state,
        activeReferrers: action.payload,
      };
    case ERROR:
      return { ...state, IsError: true, isSuccess: false };
    case SUCCESS:
      return { ...state, IsError: false, isSuccess: true };
    default:
      return state;
  }
};
export default ReferrerReducer;
